import { useContext } from 'react';

import { CompanyContext } from './index';

export function useCompany() {
  return useContext(CompanyContext);
}
